import apiVersion from '../_helpers/api-version';
import queryString from 'query-string';
import axiosInstance from '../_helpers/axiosConfig';

import { store } from '../_helpers/store';
import { authHeader } from "../_helpers/auth-header";
import httpStatus from 'http-status';

export const eventService = {
  addForm,
  getTypes,
  getEvents,
  cancelEvent,
  getEventById,
  addTelehealth,
  scheduleEvent,
  rescheduleEvent,
};

function addTelehealth(id, data) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/event/${id}/telehealth`,
    data: data
  }).then((response) => {
    return getEventById(id);
  })
}

function addForm(id, data) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/event/${id}/form`,
    data: data
  }).then((response) => {
    return getEventById(id);
  })
}

function getEventById(id) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/event/${id}`,
  }).then((response) => {
    return response.data;
  })
}

function getEvents(params = {}) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/event?${queryString.stringify(params)}`,
  }).then((response) => {
    return response.data;
  })
}

function scheduleEvent(data) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/event`,
    data: data
  }).then((response) => {
    return response.data;
  });
}

function rescheduleEvent(id, data) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'PATCH',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/event/${id}`,
    data: data
  }).then((response) => {
    return getEventById(id);
  });
}

function cancelEvent(id) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'DELETE',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/event/${id}`,
  }).then((response) => {
    return getEventById(id);
  });
}

function getTypes() {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/event-type`,
  }).then((response) => {
    if (response && response.status === httpStatus.OK) {
      return response.data;
    }
  })
}